var AvidecProductSelector = {

    initialize: function() {

        var elements = document.querySelectorAll('.product-area');

        [].forEach.call(elements, function(item) {
            item.addEventListener("mouseover", function(event) {
                var id = event.target.id;
                if (id) {
                    var products = document.querySelectorAll('.product-product.' + id);
                    [].forEach.call(products, function(item) {
                        item.classList.add('product-hover');
                    });
                }
            }, false);

            item.addEventListener("mouseout", function(event) {
                var id = event.target.id;
                if (id) {
                    var products = document.querySelectorAll('.product-product.' + id);
                    [].forEach.call(products, function(item) {
                        item.classList.remove('product-hover');
                    });
                }
            }, false);

            item.addEventListener("click", function(event) {
                var id = event.target.id;
                if (id) {
                    var all = document.querySelectorAll('.product-selector');
                    [].forEach.call(all, function(item) {
                        item.classList.remove('product-current');
                    });
                    document.getElementById(id).classList.add('product-current');
                    var products = document.querySelectorAll('.product-product.' + id);
                    [].forEach.call(products, function(item) {
                        item.classList.add('product-current');
                    });
                }
            }, false);
        });

        var products = document.querySelectorAll('.product-product');
        [].forEach.call(products, function(item) {
            var link = item.querySelector('a').href;
            item.addEventListener('click', function(event) {
                document.location.href = link;
            });
        });

    }
};

// initialize product selector on page / dom load
$(function() {
    AvidecProductSelector.initialize();
});
